var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inertia-link',{attrs:{"href":'/'}},[_c('img',{staticClass:"block h-24 w-auto",attrs:{"src":"/data/glmlic_2_icon.svg","alt":"Workflow"}})])}
var staticRenderFns = []

export { render, staticRenderFns }